export default __webpack_public_path__ + "static/media/eduGreen.38906713.svg";